import { QueryClient } from '@tanstack/react-query'

export type FmTDrawerUtils = {
  updateOpenAt: (openAt: 'showSelectTeam' | 'showMyTeams' | undefined) => void
}

export type GetFmTDrawerUtils = (queryClient: QueryClient) => FmTDrawerUtils

const getFmTDrawerUtils: GetFmTDrawerUtils = (queryClient) =>
  queryClient.getQueryData<FmTDrawerUtils>(['fmt-drawer-utils']) ??
  ({
    updateOpenAt: () => {},
  } satisfies FmTDrawerUtils)

export { getFmTDrawerUtils }
